import { useContext } from "react";
import "./navbar.css";
import { Link, useLocation } from "react-router-dom";
import { AuthContext } from "../../context/authContext";
import { auth } from "../../matabase";
import { signOut } from "firebase/auth";
const Navbar = () => {
  const location = useLocation();

  const page = location.pathname.split("/")[1];
  const cat = useLocation().search.split("=")[1];
  const { currentUser, logout } = useContext(AuthContext);
  const handleLogOut = async () => {
    try {
      await signOut(auth);
    } catch (error) {}
  };

  return (
    <div style={{ width: "100%" }} className="nav">
      <nav
        class="navbar navbar-expand-lg bg-body-tertiary navbar-dark bg-dark"
        // style={{ border: "1px solid green" }}
      >
        <div class="container-fluid">
          <a class="navbar-brand" href="/">
            <img
              src="/images/WhatsApp Image 2025-07-24 at 10.13.04_6e1f9894.jpg"
              alt=""
            />{" "}
          </a>
          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarText"
            aria-controls="navbarText"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarText">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0 ">
              {/* <li class="nav-item">
                <a
                  class={`nav-link ${!cat && "active"} `}
                  aria-current="page"
                  href="/"
                >
                  Home
                </a>
              </li> */}

              <li class="nav-item">
                <a
                  class={`nav-link ${cat == "daily-news" && "active"} `}
                  aria-current="page"
                  href="/?cat=daily-news"
                >
                  Daily News <br /> (Labarai da Rahotanni)
                </a>
              </li>
              <li class="nav-item">
                <a
                  class={`nav-link ${cat == "long-features" && "active"} `}
                  href="/?cat=long-features"
                >
                  Long features <br /> (Makala)
                </a>
              </li>
              <li class="nav-item">
                <a
                  class={`nav-link ${cat == "opinion" && "active"} `}
                  href="/?cat=opinion"
                >
                  Opinion <br /> (Ra'ayi)
                </a>
              </li>
              <li class="nav-item">
                <a
                  class={`nav-link ${cat == "life" && "active"} `}
                  aria-current="page"
                  href="/?cat=life"
                >
                  Life <br /> (Rayuwa)
                </a>
              </li>
              <li class="nav-item">
                <a
                  class={`nav-link ${cat == "videos" && "active"} `}
                  href="/?cat=videos"
                >
                  Videos <br /> (Bidiyo)
                </a>
              </li>
              <li class="nav-item">
                <a
                  class={`nav-link ${cat == "photo" && "active"} `}
                  href="/?cat=photo"
                >
                  Photos <br /> (Hotuna){" "}
                </a>
              </li>

              {/* <span class="navbar-text"> */}
              {/* </span> */}
            </ul>
            {currentUser ? (
              <div className="nav-btn">
                <Link to={"/write"} className="btn btn-primary text-white">
                  Write
                </Link>
                <button className="btn btn-danger" onClick={handleLogOut}>
                  Logout
                </button>
              </div>
            ) : (
              <div className="nav-btn">
                <Link to={"/about"} className="btn btn-primary text-white ">
                  About Us
                </Link>
                <Link to={"/contact"} className="btn btn-primary text-white">
                  Contact Us
                </Link>
              </div>
            )}
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
